import { combineReducers } from 'redux';

import mapReducer from './Map/reducer';

export default combineReducers({
	maps: mapReducer
});
